module.exports = __webpack_public_path__ + "static/Ulula-5ce37657592f3839e68b35f0cc5b0849.jpg";